import { useReducer } from 'react';

import FeatureUpgradePopup from './FeatureUpgradeDialog';
import { UpgradeContext, upgradeReducer, initialUpgradeState } from './UpgradeContext';
// Context need to register before rendering Purchase view.

const FeatureUpgradeDialogContext = (props) => {
  let storedState;
  const stateOfUpgrade = useReducer(upgradeReducer, storedState || initialUpgradeState);

  return (
    <UpgradeContext.Provider value={stateOfUpgrade}>
      <FeatureUpgradePopup {...props} />
    </UpgradeContext.Provider>
  );
};

export default FeatureUpgradeDialogContext;
